import { VueConstructor } from 'vue';

export function toViewModel(constructor: VueConstructor<Vue>): any {
    const vueInstance = new constructor();
    const options = vueInstance.$options;

    return {
        lang: options.lang,
        data: options.data,
        computed: options.computed,
        methods: options.methods,
        busEvents: options.busEvents,
        watch: options.watch,
        mixins: options.mixins,
        created: options.created,
        mounted: options.mounted,
        beforeDestroy: options.beforeDestroy,
        destroyed: options.destroyed
    };
}

export function tabValidation(config: any, direction: any) {
    // Si el tab no se visitó nunca el view model no se crea
    // consideramos que el paso no es valido
    if (!(config.viewModel instanceof NF)) {
        return false;
    }

    return config.viewModel.validate(config,direction);
}